import React, { useEffect, useState } from "react";
import storage from "../utils/storage";
import "./style.css";

const Header = () => {
  const [source, setSource] = useState("");
  const [logoPath, setLogoPath] = useState("");

  useEffect(() => {
    getSource();
  }, []);

  const getSource = () => {
    const _source = storage.getItem("source");
    setSource(_source || "");

    if (_source === "formaxpay") {
      setLogoPath("/images/formax-pay-logo.png");
    } else if (_source === "rechargepos") {
      setLogoPath("/images/recharge-pos-logo.png");
    } else if (_source === "api") {
      const _logoUrl = storage.getItem("logo_url");
      setLogoPath(_logoUrl || "");
    }
  };

  return (
    <div className="custom-header-wrapper">
      <div className="custom-header-inner">
        <a href="/">
          <img src={logoPath} alt="Logo" className="logo" />
        </a>
      </div>
    </div>
  );
};

export default Header;
